module.exports = "#p2p-results {\n  overflow: auto;\n  height: 200px;\n  border: black;\n  border-style: dashed;\n  padding: 0.5em;\n}\n\n\n"